/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Identity kind for this series
 */
export const MeterUsageSeriesKind = {
  Value: "value",
  Unset: "unset",
  Remainder: "remainder",
} as const;
/**
 * Identity kind for this series
 */
export type MeterUsageSeriesKind = ClosedEnum<typeof MeterUsageSeriesKind>;

export type MeterUsageSeries = {
  /**
   * Canonical identity; present for value series and omitted for unset and remainder
   */
  key?: string | undefined;
  /**
   * Identity kind for this series
   */
  kind: MeterUsageSeriesKind;
  /**
   * Display label, never chart identity
   */
  label: string;
  /**
   * Exact integer ordinary usage series total as a decimal string
   */
  total: string;
  /**
   * Exact integer ordinary usage values aligned one-for-one with buckets
   */
  values: Array<string>;
};

/** @internal */
export const MeterUsageSeriesKind$inboundSchema: z.ZodMiniEnum<
  typeof MeterUsageSeriesKind
> = z.enum(MeterUsageSeriesKind);

/** @internal */
export const MeterUsageSeries$inboundSchema: z.ZodMiniType<
  MeterUsageSeries,
  unknown
> = z.object({
  key: z.optional(z.string()),
  kind: MeterUsageSeriesKind$inboundSchema,
  label: z.string(),
  total: z.string(),
  values: z.array(z.string()),
});

export function meterUsageSeriesFromJSON(
  jsonString: string,
): SafeParseResult<MeterUsageSeries, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MeterUsageSeries$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MeterUsageSeries' from JSON`,
  );
}
